import React, { useState, useEffect } from 'react';
import { Text, DateFilter, FilterGroup } from '../../app-components';
import { MODELS, ROUTES } from '../../Lib/constants';
import vars from '../../theme/vars';
import Welcome from './homeScreen';
import EmailOfferListScreen from './EmailOffer/EmailLists';
import SMSOfferListScreen from './SMSOffer/list';
import PrintOfferListScreen from './PrintOffer/list';
import AVFailListScreen from './Fail/list';
import EmailOfferListScreenSA from './EmailOfferSA/list';
import SMSOfferListScreenSA from './SMSOfferSA/lists';
import PrintOfferListScreenSA from './PrintOfferSA/lists';
import AVFailListScreenSA from './FailSA/lists';
import { ManualAppraisalPopup } from './ManualAppraisalPopup';
import FtsSearch from '../../Components/TableFilters/FtsSearch';
import { filterLogo } from '../../images';
import { searchOptionsFilter } from '../../autoSuggestions'

import './loader.css'
import EmailLists from './EmailOffer/EmailLists';
const { headings } = vars;
const textStyle = { ...headings.pageHeading, marginLeft: 12 };


export default {
  [ROUTES.WelcomeSA.name]: {
    screen: Welcome,
    expanded: true,
    reloadEvent: ROUTES.WelcomeSA.name,
    title: <Text style={textStyle}>Check Activities Here</Text>,
    headerActions: [
      FilterGroup({
        icon: filterLogo,
        activeIcon: filterLogo,
        appliedIcon: filterLogo,
        imageStyle: { width: 24, height: 24 },
        filters: [
          searchOptionsFilter({
            field: 'username',
            model: MODELS.Dealer,
            id: 'dealersListForTable',
            searchField: 'username',
            label: 'Dealers',
            valueField: '_id',
            suggestionField: 'username',
            multiSelect: false,
          }),
          {
            type: 'date',
            field: 'checkDate',
            label: 'Time Period',
            asParam: true,
          },
        ],
      }),
    ],
  },

  [ROUTES.emailOfferList.name]: {
    screen: EmailLists,
    expanded: true,
    // title: <Text style={textStyle}>Email Offers Generated</Text>,
    // headerActions: [<DateFilter field="onDate" key="onDate" />],
  },

  [ROUTES.emailOfferListSA.name]: {
    screen: EmailLists,
    expanded: true,
    // title: <Text style={textStyle}>Email Offers Generated</Text>,
    // headerActions: [{ render: <Text /> }],
  },

  [ROUTES.smsOfferList.name]: {
    screen: SMSOfferListScreen,
    expanded: true,
    // title: <Text style={textStyle}>SMS Offers Generated</Text>,

    // headerActions: [<DateFilter field="onDate" key="onDate" />],
  },

  [ROUTES.smsOfferListSA.name]: {
    screen: SMSOfferListScreenSA,
    expanded: true,
    // title: <Text style={textStyle}>SMS Offers Generated</Text>,

    // headerActions: [{ render: <Text /> }],
  },

  [ROUTES.printOfferList.name]: {
    screen: PrintOfferListScreen,
    expanded: true,
    // title: <Text style={textStyle}>Print Offers Generated</Text>,

    // headerActions: [<DateFilter field="onDate" key="onDate" />],
  },

  [ROUTES.printOfferListSA.name]: {
    screen: PrintOfferListScreenSA,
    expanded: true,
    // title: <Text style={textStyle}>Print Offers Generated</Text>,

    // headerActions: [{ render: <Text /> }],
  },

  [ROUTES.avFailList.name]: {
    screen: AVFailListScreen,
    expanded: true,

  },

  [ROUTES.avFailListSA.name]: {
    screen: AVFailListScreenSA,
    expanded: true,
  },

  [ROUTES.WelcomeDealer.name]: {
    screen: Welcome,
    expanded: true,
    reloadEvent: ROUTES.WelcomeDealer.name,
    title: <Text style={textStyle}>Check Your Activities Here</Text>,
    headerActions: [],
  },

  'manual-appraisal-modal': {
    screen: ManualAppraisalPopup,
    modal: true,
    modalProps: {
      width: 400,
      height: 300,
    },
  },


};
